import { useEffect } from 'react';
import { ORDAN_TEAL, PRODUCT_CATEGORY, PRODUCT_NAME, WITHU_BRAND } from '@/constants/brand';
import { getLoginEntryPath } from '@/utils/safeReturnUrl';

export interface ProductBrand {
  isWithu: boolean;
  name: string;
  /** Wordmark colour for the app chrome. */
  color: string;
}

/** Sessions started from `/loginwithu` show the WITHU demo name; all others stay ORDAN. */
export function useProductBrand(): ProductBrand {
  const isWithu = getLoginEntryPath() === '/loginwithu';
  return isWithu
    ? { isWithu, name: WITHU_BRAND.name, color: WITHU_BRAND.navy }
    : { isWithu, name: PRODUCT_NAME, color: ORDAN_TEAL };
}

/** Keeps the browser tab title on the active product name while the app shell is mounted. */
export function useProductDocumentTitle(brand: ProductBrand): void {
  useEffect(() => {
    if (!brand.isWithu) return undefined;
    const previous = document.title;
    document.title = `${brand.name} - ${PRODUCT_CATEGORY}`;
    return () => {
      document.title = previous;
    };
  }, [brand.isWithu, brand.name]);
}
